import React from 'react';
import { PropInfo, CodeExample, SelectProps } from '@cimpress/react-components';

import SelectCode from '!raw-loader!./select.jsx';
import SelectDemo from './select.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const SelectDocs = () => {
  const propInfos: PropInfo<SelectProps>[] = [
    {
      name: 'containerClassName',
      type: 'string',
      default: '',
      description: 'A class name to append to the div that wraps the select component.',
    },
    {
      name: 'label',
      type: 'string',
      default: '',
      description:
        'Label for the select field.  If you provide a `placeholder` (per react-select props), it will be used as the label.',
    },
    {
      name: 'helpText',
      type: 'node',
      default: '',
      description: 'Additional help text to display under the select field.',
    },
    {
      name: 'status',
      type: 'string',
      default: '',
      description: (
        <div>
          One of <code>success</code>, <code>warning</code>, or <code>error</code>, provides a validation state.
        </div>
      ),
    },
  ];

  const remarks = (
    <div>
      <p>
        This select is a thin layer of interactivity layered over{' '}
        <a href="https://github.com/JedWatson/react-select" target="_blank" rel="noopener noreferrer">
          react-select
        </a>{' '}
        to provide a consistent look and feel with the rest of the component library. Refer to the{' '}
        <a href="https://github.com/JedWatson/react-select#select-props" target="_blank" rel="noopener noreferrer">
          react-select props documentation
        </a>{' '}
        for the rest of the list of props available.
      </p>
      <p>
        <strong>Note:</strong> As of version 14.x, the <code>tether</code> prop, used for improved layering behavior of
        the Select's options, has been removed in preference for the <code>menuPortalTarget</code> prop supported by
        react-select. Please see react-select documentation for more details. If you find that the option list is hidden
        or covered by other elements, <code>menuPortalTarget</code> is probably the fix you're looking for.
      </p>
      <p>
        To keep the bundle size small, only one select has been included in this package. If you wish to use a different
        Select (such as{' '}
        <a href="https://github.com/bvaughn/react-virtualized-select" target="_blank" rel="noopener noreferrer">
          react-virtualized-select
        </a>{' '}
        or{' '}
        <a href="https://github.com/HubSpot/react-select-plus" target="_blank" rel="noopener noreferrer">
          react-select-plus
        </a>
        ) you can use the <a href="#SelectWrapper">SelectWrapper</a> with another supported Select to obtain the
        interactivity.
      </p>
    </div>
  );

  return (
    <ComponentDoc name="Select" propInfos={propInfos} remarks={remarks}>
      <SelectDemo />
      <CodeExample code={SelectCode} />
    </ComponentDoc>
  );
};

export default SelectDocs;
